import React, { useState } from 'react';
import MovieList from '../movielist/movielist';
import './category.css'

const Category = () => {
    const [genre, setGenre] = useState('All')
    return (
        <>
        <div className="btn-wrapper">
            <h4>Browse by category</h4>
            <div className="category-btn">
                <button onClick={()=>setGenre('All')}>All</button>
                <button onClick={()=>setGenre('Anime')}>Anime</button>
                <button onClick={()=>setGenre('Action')}>Action</button>
                <button onClick={()=>setGenre('Adventure')}>Adventure</button>
                <button onClick={()=>setGenre('Sciense Fiction')}>Science Fiction</button>
                <button onClick={()=>setGenre('Comedy')}>Comedy</button>
            </div>
        </div>
        <MovieList genre={genre} />
        </>
    );
};

export default Category;